export default {
  roles: (state, getters) => {
    return Object.values(state.roles).map(role => {
      return {
        ...role,
        entitlements: Object.keys(role.entitlements).reduce((entitlements, entitlement) => {
          entitlements[entitlement] = role.entitlements[entitlement] instanceof Object && role.entitlements[entitlement].constructor === Array
            ? role.entitlements[entitlement]
            : role.entitlements[entitlement].split(',')
          return entitlements
        }, {}),
        users_count: getters.admins.filter(admin => parseInt(admin.role_id) === role.id).length
      }
    })
  },
  admins: (state) => {
    return Object.values(state.admins)
  },
  currentAdminRoleId: (state) => (currentLogin) => {
    return Object.values(state.admins).filter(admin => admin.email === currentLogin)[0]
  },
  entitlements: (state) => {
    return Object.keys(state.entitlements).map(entitlement => {
      return {
        id: entitlement,
        name: entitlement,
        actions: state.entitlements[entitlement].map(action => {
          return { id: `${entitlement}-${action}`, name: action }
        })
      }
    })
  }
}
